"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "RequestError", {
  enumerable: true,
  get: function get() {
    return _request.RequestError;
  }
});
Object.defineProperty(exports, "ResponseError", {
  enumerable: true,
  get: function get() {
    return _request.ResponseError;
  }
});
exports.appendCToken = appendCToken;
Object.defineProperty(exports, "cookie", {
  enumerable: true,
  get: function get() {
    return _jsCookie.default;
  }
});
exports.createKvMapAndOptions = createKvMapAndOptions;
Object.defineProperty(exports, "defaultDateFormatter", {
  enumerable: true,
  get: function get() {
    return _format.defaultDateFormatter;
  }
});
Object.defineProperty(exports, "defaultDateTimeFormatter", {
  enumerable: true,
  get: function get() {
    return _format.defaultDateTimeFormatter;
  }
});
Object.defineProperty(exports, "extendRequest", {
  enumerable: true,
  get: function get() {
    return _request.extend;
  }
});
Object.defineProperty(exports, "getCToken", {
  enumerable: true,
  get: function get() {
    return _ctoken.default;
  }
});
exports.getOptionLabel = getOptionLabel;
exports.getTableFilterCls = getTableFilterCls;
Object.defineProperty(exports, "queryString", {
  enumerable: true,
  get: function get() {
    return _queryString.default;
  }
});
Object.defineProperty(exports, "request", {
  enumerable: true,
  get: function get() {
    return _request.default;
  }
});
Object.defineProperty(exports, "umiRequest", {
  enumerable: true,
  get: function get() {
    return _request.request;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _queryString = _interopRequireDefault(require("query-string"));

var _ctoken = _interopRequireDefault(require("./ctoken"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _url = _interopRequireDefault(require("url"));

var _request = _interopRequireWildcard(require("./request"));

var _format = require("./format");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * 根据传入的数组来生成 key-value map(kvMap) 和用于 ui 选择的 options(options) 数组
 *
 * 适用于同时需要展示 ui，也需要根据 value 来判断的场景
 *
 * 生成的 kvMap，key 是入参数组项的 name 属性，value 是入参数组项的的 code。
 * 生成的 options 中的项，是一个 json 对象，label 是 入参数组项的 message，value 是入参数组项的 code
 *
 * [{ name: 'a', value: 1, label: 'ma'}, { name: 'b', value: 2, label: 'mb'}]
 *
 * =>
 *
 * kvMap: {a: 1, b: 2}
 * options: [{ label: 'ma', value: 1 }, { label: 'mb', value: 2 }]
 *
 * @param {Array<{name, value, label}>} list 传入的数组，name 是标识，value 是实际使用的 value，label 是展示用的 message。如果 name 和 value 相同，那么可以省略 name
 * @return {{kvMap: Object, options: Array<Option>}}
 */
function createKvMapAndOptions(list) {
  var options = [];
  var kvMap = {};
  list.forEach(function (i) {
    options.push(_objectSpread(_objectSpread({}, i), {}, {
      label: i.label,
      value: i.value
    })); // 如果 name 和 value 同名，那么可以省略 name

    kvMap[i.name || i.value] = i.value;
  });
  return {
    kvMap: kvMap,
    options: options
  };
}
/**
 * 获取 option value 对应的 label
 * @param optionList 选项列表
 * @param optionValue 选项值
 * @param labelKey 选项文案 key，默认是 label
 * @param valueKey 选项值 key，默认是 value
 * @returns {any}
 */


function getOptionLabel(optionList, optionValue) {
  var labelKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'label';
  var valueKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'value';
  var item = optionList.find(function (option) {
    return option[valueKey] === optionValue;
  });
  return item ? item[labelKey] : '';
}
/**
 * 根据 table 列是否有设置筛选值来设置不同的 class，配合颜色样式来做突出展示用
 *
 * 用法是在 table 组件的 column 配置中添加
 * className: getTableFilterCls(filterParams, dataIndex)
 *
 * 一般搭配类似这样的样式使用
 *
 * .whale-table {
 *  .next-table {
 *    .active-filter .next-icon {
 *      color: #0284fd;
 *      font-weight: bold;
 *    }
 *  }
 * }
 *
 * @param filterParams table 列筛选配置值
 * @param filterName table 列 key
 * @param activeFilterCls 有筛选值时添加的 className，默认是 active-filter
 * @returns {string} 列额外配置的 className 字符串
 */


function getTableFilterCls(filterParams, filterName) {
  var activeFilterCls = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'active-filter';

  if (!filterParams) {
    return '';
  }

  var filter = filterParams[filterName];

  if (!filter) {
    return '';
  }

  var selectedKeys = filter.selectedKeys;
  return !selectedKeys || selectedKeys.length <= 0 ? '' : activeFilterCls;
} // 给 url 添加 csrf token


function appendCToken(url) {
  var cTokenKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ctoken';

  var parsed = _queryString.default.parseUrl(url, {
    parseFragmentIdentifier: true
  });

  var query = parsed.query;
  var token = (0, _ctoken.default)();
  var newUrl = url;

  if (token) {
    query[cTokenKey] = token;
    newUrl = _queryString.default.stringifyUrl(query);
  }

  return newUrl;
}